// frontend/src/pages/Dashboard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useFarm } from '../context/FarmContext';
import FarmSummary from '../components/dashboard/FarmSummary';
import PlotConditions from '../components/dashboard/PlotConditions';
import RiskForecast from '../components/dashboard/RiskForecast';
import './Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const {
    selectedFarmId,
    selectedPlotId,
    selectedPlotData,
    selectedPlotDevices,
    loading
  } = useFarm();

  const handleRiskModelSelect = (modelDetails) => {
    if (modelDetails?.farmId && modelDetails?.site_id) {
      navigate(`/dashboard/farm/${modelDetails.farmId}/plot/${modelDetails.site_id}`, {
        state: modelDetails
      });
    }
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-grid">
        {/* 1. Farm Summary Panel */}
        <FarmSummary />

        {/* 2. Plot Current Conditions Panel */}
        <PlotConditions plotData={selectedPlotData} loading={loading} />

        {/* 3. Dedicated 5-Day Risk Forecast Panel */}
        <RiskForecast
          farmId={selectedFarmId}
          plotId={selectedPlotId}
          onSelectRiskModel={handleRiskModelSelect}
        />
      </div>
    </div>
  );
};

export default Dashboard;
